<template>
  <component
    :is="`${unordered ? 'ul' : 'ol'}`"
    :class="['list', unordered ? `unordered-list` : `ordered-list`]"
  >
    <template v-for="item in items" :key="item.content">
      <li>
        <span v-html="clean(item.content, { sanitize: true, externalLinks: true })"></span>
        <List v-if="item.items" :unordered="unordered" :items="item.items" />
      </li>
    </template>
  </component>
</template>

<script setup lang="ts">
// Usage: <List :unordered="true" :items="items" />
// :unordered is optional, default is false
// :items is required, must be an array of objects with a title property
// and an optional items property that is an array of objects with a title property

defineProps({
  unordered: {
    type: Boolean,
    default: null,
  },
  items: {
    type: Array as () => Array<{ content: string; items?: Array<{ content: string }> }>,
    default: () => [],
  },
});

const { clean } = useCleanHtml();
</script>

<style scoped lang="postcss">
.list {
  --padding-left: var(--unit-18);

  @media (--lg-viewport) {
    --padding-left: var(--unit-20);
  }
}

.unordered-list,
.ordered-list {
  ul,
  ol {
    counter-reset: item;
  }
}

.unordered-list {
  padding-left: var(--padding-left);
  list-style: disc;
}

.ordered-list {
  counter-reset: item;

  li {
    display: block;
    position: relative;

    &::before {
      content: counters(item, '. ') '. ';
      counter-increment: item;
      display: inline-block;
      text-align: right;
      margin-right: var(--unit-6);
    }

    ol {
      padding-left: var(--padding-left);
    }
  }
}
</style>
